
define('ldsh!modules/editor/templates/correodirect_fields_itemview', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="ed-form-group ed-form-group-inline js-fieldmapping ed-user-item" data-field="' +
((__t = (nameAttr)) == null ? '' : __t) +
'">\n  <label class="col-md-3 control-label js-expand">\n    ';
 if (hasIntegrableOptions) { ;
__p += '\n    <span class="ri-arrow-down-s-line"></span>\n    ';
 } ;
__p += '\n    ' +
((__t = ( nameAttr )) == null ? '' : __t) +
'\n  </label>\n  <select class="ed-form-control ed-form-item-full js-correodirect-fields" data-field="' +
((__t = (nameAttr)) == null ? '' : __t) +
'"></select>\n</div>\n<div class="ed-fieldmapping-wrap-user js-options hidden"></div>';

}
return __p
};});

